export default {
  // 加載文本
  loading: "拼命加載中",
  
  // 標題和標籤
  sharePermission: "分享權限",
  validPeriod: "有效期",
  addressHiding: "地址隱藏",
  canvasData: "畫布數據",
  shareLink: "分享鏈接",
  accessPassword: "訪問密碼",
  
  // 選項
  viewOnlyOption: "僅查看畫布（不需要登錄，輸入密碼即可訪問）",
  copyableOption: "可複製畫布（輸入密碼可訪問，允許用戶複製畫布，需要用戶登錄）",
  
  // 有效期選項
  day1: "1天",
  day3: "3天",
  day7: "7天",
  day14: "14天",
  day30: "30天",
  
  // 地址隱藏選項
  no: "否",
  yes: "是",
  
  // 畫布數據
  tag: "標籤",
  nodeComment: "節點備註",
  showAll: "顯示全部",
  show: "顯示",
  
  // 按鈕
  copyLink: "複製鏈接",
  confirm: "確認",
  
  // 消息
  expiredHint: "有效期已過期，點擊下方按鈕重新分享",
  copySuccess: "複製成功",
  
  // 複製文案
  sharedCanvasFrom: "用戶uid{uid}向您分享了他(她)的 {canvasName} 畫布",
  link: "鏈接：",
  password: "密碼：",
  validityPeriod: "有效期：",
  copyPermissionAllowed: "複製畫布權限：允許",
  addressHidingYes: "地址隱藏 : 是",
  note: "請注意，這個鏈接有設置權限和有效期限制，請確保在有效期內輸入密碼進行訪問",
  
  // 占位符
  pleaseSelect: "請選擇",
};
